import {
  FilterItemNode,
  ResourceType,
} from "../../../../../../../services/cloudchipr.api";

export type KubernetesResourcePodsRequestFiltersData = {
  resourceType: ResourceType;
  resourceId: string;
  resourceName: string;
  clusterId: string;
};

export const generateKubernetesResourcePodsRequestFilters = ({
  resourceType,
  resourceName,
  resourceId,
  clusterId,
}: KubernetesResourcePodsRequestFiltersData) => {
  const filterItems: FilterItemNode[] = [
    {
      node_type: "item",
      operator: "in",
      type: "cluster",
      filter_provider: "kubernetes",
      value: [clusterId],
    },
  ];

  if (["kubernetes_node", "kubernetes_namespace"].includes(resourceType)) {
    const filterValue =
      resourceType === "kubernetes_node" ? resourceId : resourceName;

    filterItems.push({
      node_type: "item",
      operator: "in",
      type: resourceType === "kubernetes_node" ? "node" : "namespace",
      filter_provider: "kubernetes",
      value: [filterValue],
    });

    return filterItems;
  }

  const workloadType = workloadTypeByResourceType[resourceType];

  if (!workloadType) {
    return filterItems;
  }

  filterItems.push({
    node_type: "item",
    operator: "in",
    type: "workload_name",
    filter_provider: "kubernetes",
    value: [resourceName],
  });

  filterItems.push({
    node_type: "item",
    operator: "in",
    type: "workload_type",
    filter_provider: "kubernetes",
    value: [workloadType],
  });

  return filterItems;
};

const workloadTypeByResourceType: Partial<Record<ResourceType, string>> = {
  kubernetes_deployment: "Deployment",
  kubernetes_stateful_set: "StatefulSet",
  kubernetes_daemon_set: "DaemonSet",
};
